import { DateTime } from 'luxon';
import { ISearchOrdersSpecificationData } from '../../ui-toolkit/orders/searchOrder/types/ISearchOrdersSpecification';
import { eSearchOrdersOrderBy } from '../../ui-toolkit/orders/searchOrder/types/eSearchOrdersOrderBy';

export const createPcDashboardDefaultSearchOrderSpecification = (): ISearchOrdersSpecificationData => {
  const specifications = {
    pageNumber: 0,
    pageSize: 20,
    sortBy: eSearchOrdersOrderBy.closingDateASC,
    allowMultiple: true,
  };
  return specifications;
};

export const ordersCreatedTodaySpecification = (): ISearchOrdersSpecificationData => {
  const today = DateTime.local().toFormat('yyyy-MM-dd');
  const tomorrow = DateTime.local().plus({ day: 1 }).toFormat('yyyy-MM-dd');
  const specifications = {
    ...createPcDashboardDefaultSearchOrderSpecification(),
    createdAtStart: today,
    createdAtEnd: tomorrow,
  };
  return specifications;
};

export const ordersClosingTodaySpecification = (): ISearchOrdersSpecificationData => {
  const today = DateTime.local().toFormat('yyyy-MM-dd');
  const specifications = {
    ...createPcDashboardDefaultSearchOrderSpecification(),
    closingDateStart: today,
    closingDateEnd: today,
  };
  return specifications;
};

export const ordersClosingTomorrowSpecification = (): ISearchOrdersSpecificationData => {
  const tomorrow = DateTime.local().plus({ day: 1 }).toFormat('yyyy-MM-dd');
  const specifications = {
    ...createPcDashboardDefaultSearchOrderSpecification(),
    closingDateStart: tomorrow,
    closingDateEnd: tomorrow,
  };
  return specifications;
};
